import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { WebcamImage } from 'ngx-webcam';
import { MasterService } from 'src/app/services/master.service';
import { BoardResponse } from 'src/app/model/BoardResponse';
import { ModalController, ToastController } from "@ionic/angular";
import { AuthorityResponse } from 'src/app/model/AuthorityResponse';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderComponent } from '../loader/loader.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-walkin-appointment',
  templateUrl: './walkin-appointment.component.html',
  styleUrls: ['./walkin-appointment.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class WalkinAppointmentComponent implements OnInit {
  form: FormGroup;
  selectedFile: File | null = null;
  selectedFileBase64: string | ArrayBuffer;
  trigger: Subject<void> = new Subject<void>();
  showWebcam: boolean = false;
  capturedImage: string | ArrayBuffer = null;
  boardResponse: BoardResponse;
  authorityResponse: AuthorityResponse;
  authorityList: any[] = [];
  uploadedLivePhoto: File;
  uploadedLivePhotoBase64: string | ArrayBuffer;
  showPhoto: boolean = false;
  isSubmitDisabled: boolean = false;
  showOtherAuthorityInput: boolean = false;
  progressSpinnerDialog: any = null;
  showFetchButton = false;
  videoOptions: MediaTrackConstraints = {
    width: { ideal: 350 },
    height: { ideal: 240 },
    facingMode: 'user'
  };
  
  private _snackBar: MatSnackBar

  constructor(private fb: FormBuilder, private http: HttpClient,
    private masterService: MasterService,
    private toastController: ToastController,
    private router: Router,
    private dialog: MatDialog,
    
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', Validators.required],
      // mobileNumber: ['', [Validators.required, Validators.maxLength(10)]],
      mobileNumber: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    //  aadhaar: [''],
      pan: [''],
    //  documentType: [''],
      aadhaar: ['', Validators.required], // make Document ID mandatory
      documentType: ['', Validators.required], // make Document Type mandatory
      subject:['',Validators.required],
      board: ['', Validators.required],
      authority: ['', Validators.required],
      capturephoto: ['', Validators.required],
      otherAuthority: ['']
    });

    this.getBoard();
    this.form.get('mobileNumber')?.valueChanges.subscribe(value => {
      if (value && value.length === 10) {
      //  this.fetchWalkinDetails();
      }
    });
  }


  // onMobileInput() {
  //   const mobileControl = this.form.get('mobileNumber');
  //   const mobileNumber = mobileControl?.value || '';
  
  //   if (mobileNumber.length < 10) {
  //     const currentMobile = mobileNumber; 
  
  //     this.form.reset(); 
  //     mobileControl?.setValue(currentMobile); 
  
  //     this.capturedImage = null;
  //     this.form.get('capturephoto')?.setValue(null);
  //     this.form.get('capturephoto')?.markAsTouched();
  //     this.showPhoto = false;
  //   }
  // }
  

  /// onMobileInput() {
  ///   const mobileControl = this.form.get('mobileNumber');
  ///   const mobileNumber = mobileControl?.value || '';
  
    // Only clear fields if mobile number is completely empty (or you can choose to check some other condition)
    // if (mobileNumber.length === 0) {
    //   // Clear dependent fields only if mobile number is empty
    //   this.form.patchValue({
    //     name: '',
    //     aadhaar: '',
    //     pan: '',
    //     documentType: '',
    //     subject: '',
    //     board: '',
    //     authority: '',
    //     otherAuthority: '',
    //     capturephoto: ''
    //   });
  
    //   this.showOtherAuthorityInput = false;
    //   this.capturedImage = null;
    //   this.showPhoto = false;
    //   this.form.get('capturephoto')?.setValue(null);
    //   this.form.get('capturephoto')?.markAsTouched();
    // }
  ///}
  
  onMobileInput(): void {
    const mobileNumber = this.form.get('mobileNumber')?.value || '';
    this.showFetchButton = /^\d{10}$/.test(mobileNumber);
  }
  
  getBoard() {
    this.masterService.fetchBoardList().subscribe((res) => {
      if (res) {
        this.boardResponse = res;
        console.log('Board list loaded:', this.boardResponse);
      }
    });
  }

  onNameInput(event: any) {
    const input = event.target.value.toUpperCase().replace(/[^A-Z ]/g, ''); // allows A-Z and space
    this.form.get('name')?.setValue(input, { emitEvent: false });
  }
  
  // onAuthorityChange(value: any): void {
  //   this.showOtherAuthorityInput = value === 'OTHER';
  
  //   const otherControl = this.form.get('otherAuthority');
  //   if (this.showOtherAuthorityInput) {
  //     otherControl?.setValidators([Validators.required]);
  //   } else {
  //     otherControl?.clearValidators();
  //     otherControl?.setValue('');
  //   }
  //   otherControl?.updateValueAndValidity();
  // }
  
  onAuthorityChange(value: any): void {
    this.showOtherAuthorityInput = value === 'OTHER';
  
    const otherControl = this.form.get('otherAuthority');
    if (this.showOtherAuthorityInput) {
      otherControl?.setValidators([Validators.required]);
    } else {
      otherControl?.clearValidators();
      otherControl?.setValue('');
    }
    otherControl?.updateValueAndValidity();
  }
  
  
  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.selectedFileBase64 = reader.result;
      };
    }
    else {
      this.selectedFile = null;
      this.selectedFileBase64 = null;
    }
  }

  toggleWebcam() {
    this.showWebcam = !this.showWebcam;
    if (!this.showWebcam) {
      this.capturedImage = null;
      this.form.get('capturephoto')?.setValue(null); // Set to null
      this.form.get('capturephoto')?.markAsTouched();
      this.showPhoto = false;
    }else if(this.showWebcam){
      this.capturedImage = null;
      this.form.get('capturephoto')?.setValue(null); // Set to null
      this.form.get('capturephoto')?.markAsTouched();
      this.showPhoto = false;
    }
  }

  handleImage(webcamImage: WebcamImage) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const img = new Image();
    img.src = webcamImage.imageAsDataUrl;

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      context?.scale(-1, 1);
      context?.drawImage(img, -img.width, 0);
      this.capturedImage = canvas.toDataURL();
      
      this.form.get('capturephoto')?.setValue(this.capturedImage);
      this.form.get('capturephoto')?.updateValueAndValidity();
      this.showWebcam = false;
      this.showPhoto = true;
    };
  }

  captureImage() {
    this.trigger.next(); // Trigger capturing image
    this.saveAndSendImage();
  }

  saveAndSendImage() {
    if (this.capturedImage) {
      const blob = this.dataURItoBlob(this.capturedImage as string); // Cast to string
      const file = new File([blob], 'webcam_image.jpg');
      this.uploadedLivePhoto = file;
      this.readImage(file);
    }
  }

  readImage(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      console.log('in webcam');
      const img = new Image();
      img.src = e.target.result;
      img.onload = async () => {
        // Any additional processing like adding location can be done here
      };
      console.log('webcam', reader.result);
      // this.uploadedLivePhotoBase64 = reader.result;
    };
    reader.readAsDataURL(file);
  }

  dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }

  submitAppointment(): void {
    if (this.form.invalid) {
      this.isSubmitDisabled = false;
      console.warn('Form is invalid');
      return;
    }
  
    if (this.selectedFile) {
      console.log('Uploaded Document File:', this.selectedFile);
    } else {
      console.log('No document uploaded.');
    }
  
    if (this.capturedImage) {
      const blob = this.dataURItoBlob(this.capturedImage as string);
      const file = new File([blob], 'webcam_image.jpg');
      this.uploadedLivePhoto = file;
      console.log('Captured Image File:', this.uploadedLivePhoto);
    } else {
      console.log('No webcam photo captured.');
    }
  
    const authorityValue = this.form.get('authority')?.value;
    const isOtherAuthority = authorityValue === 'OTHER';
    this.displayProgressSpinner();
    this.masterService.submitWalkinDetails({
      name: this.form.get('name')?.value,
      mobileNumber: this.form.get('mobileNumber')?.value,
      aadhaar: this.form.get('aadhaar')?.value,
      documentType: this.form.get('documentType')?.value,
      authority: isOtherAuthority ? null : authorityValue,
      otherAuthority: isOtherAuthority ? this.form.get('otherAuthority')?.value : null,
      board: this.form.get('board')?.value,
      document: this.selectedFile ? this.selectedFileBase64 : null,
      photo: this.uploadedLivePhoto ? this.capturedImage : null,
      subject: this.form.get('subject')?.value
    }).subscribe({
      next: (res) => {

        console.log('Data submitted successfully', res);
        this.progressSpinnerDialog.close();
        this.router.navigate(["/secure", "walkin-appointment-list"]);
      },
      error: (err) => {
        this.progressSpinnerDialog.close();
        this.isSubmitDisabled = false;
        console.error('Error submitting form', err);
        alert('Error occurred while submitting the form.');
      }
    });
  }
  
  

  callBoard() {
    this.fetchAuthorityList();
  }

  fetchAuthorityList() {
    this.masterService.fetchAuthorityListInit(this.form.value.board).subscribe((authorityResponse) => {
      if (authorityResponse.status === "SUCCESS") {
        this.authorityResponse = authorityResponse;
        this.authorityList = authorityResponse.authorityList;
      } else {
        this.showErrorToast(authorityResponse.errorMessage);
      }
    });
  }

  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      cssClass: "toast error-toast",
      duration: 4000,
    });
    toast.present();
  }

  back(): void {
    window.history.back();
  }
  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  alphanumericOnly(event: any) {
    const input = event.target.value.toUpperCase(); // no filtering
    this.form.get('aadhaar')?.setValue(input, { emitEvent: false });
  }
  
 
fetchWalkinDetails() {
  const mobileNumber = this.form.get('mobileNumber')?.value;
  if (!mobileNumber || mobileNumber.length !== 10) {
    this.errorToast('Please enter a valid 10-digit mobile number.');
    return;
  }

  // 🔄 Reset previously fetched data
  this.form.patchValue({
    name: '',
    aadhaar: '',
    pan: '',
    documentType: '',
    subject: '',
    board: '',
    authority: '',
    otherAuthority: '',
    capturephoto: ''
  });
  this.showOtherAuthorityInput = false;
  this.selectedFileBase64 = null;
  this.capturedImage = null;
  this.showPhoto = false;

  this.displayProgressSpinner();

  this.masterService.fetchWalkinDetailsByMobile(mobileNumber).subscribe({
    next: (data) => {
      this.progressSpinnerDialog.close();

      if (data) {
        this.form.patchValue({
          name: data.name,
          aadhaar: data.aadhaar,
          pan: data.pan,
          documentType: data.documentType,
          subject: data.subject,
          board: data.board,
          authority: data.authority || '',
          otherAuthority: data.otherAuthority || ''
        });

        if (data.authority === 'OTHER') {
          this.showOtherAuthorityInput = true;
        }

        if (data.document) {
          this.selectedFileBase64 = data.document;
        }

        if (data.photo) {
          this.capturedImage = data.photo;
          this.form.get('capturephoto')?.setValue(data.photo);
          this.showPhoto = true;
        }

        this.fetchAuthorityList();
      }
    },
    error: (err) => {
      this.progressSpinnerDialog.close();

      if (err.status === 404) {
        this.errorToast('No data found for the provided mobile number.');
      } else {
        console.error('Error fetching walk-in details:', err);
        this.errorToast('An error occurred while fetching details.');
      }
    }
  });
}

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

    async displayProgressSpinner() {
       this.progressSpinnerDialog = this.dialog.open(LoaderComponent, {
         disableClose: true,
         panelClass: "progressSpinner",
       });
     }
  
}